import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { ApplicationListItemModel } from '../../../shared/models/application-list-item.model';

export type PagedResponse<T> = {
    items: T[];
    total: number;
    page: number;
    pageSize: number;
};

@Injectable({
    providedIn: 'root',
})
export class ApplicationListItemService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/application_list_items`;

    // Read all applications
    getAllLoanApplications(): Observable<ApplicationListItemModel[]> {
        return this.get(`${this.apiUrl}/all`);
    }

    getUsersLoanApplications(): Observable<ApplicationListItemModel[]> {
        return this.get(`${this.apiUrl}`);
    }

    getAllLoanApplicationsPaged(params: { page: number; pageSize: number; q?: string; branchLocationUuid?: string }): Observable<PagedResponse<ApplicationListItemModel>> {
        return this.get(`${this.apiUrl}/all/paged`, {
            params: {
                page: params.page,
                pageSize: params.pageSize,
                q: params.q ?? '',
                branchLocationUuid: params.branchLocationUuid ?? '',
            },
        });
    }

    getUsersLoanApplicationsPaged(params: { page: number; pageSize: number; q?: string }): Observable<PagedResponse<ApplicationListItemModel>> {
        return this.get(`${this.apiUrl}/paged`, {
            params: {
                page: params.page,
                pageSize: params.pageSize,
                q: params.q ?? '',
            },
        });
    }
}
